import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Component } from 'react';
import { isMobileApp } from 'utils';
import Dino from 'console/images/Dinosaur.svg';
import { Box, Button, Link, Typography } from '@mui/material';
import { Language, Replay } from '@mui/icons-material';
import branding from 'shared/app/model/branding';
import { CustomIcon } from 'shared/components/icon/custom';
import { exitApp } from 'shared/app/lib/exit-app';
export function ErrorBoundaryView(props) {
    const { title, onClick } = props;
    return (_jsxs(Box, { display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "column", gap: 1, height: "100%", width: "100%", fontSize: "200%", fontWeight: "100", lineHeight: 2, children: [_jsx(CustomIcon, { Icon: Dino, width: 50, height: 75 }), _jsx(Typography, { variant: "h2", children: title }), _jsxs(Box, { children: [isMobileApp() ? (_jsx(Button, { onClick: exitApp, variant: "contained", startIcon: _jsx(Replay, {}), fullWidth: true, children: "\u041F\u043E\u043F\u0440\u043E\u0431\u0443\u0439\u0442\u0435 \u043F\u0435\u0440\u0435\u0437\u0430\u043F\u0443\u0441\u0442\u0438\u0442\u044C \u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u0435" })) : (_jsx(Button, { onClick: onClick ?? (() => window.location.reload()), variant: "contained", startIcon: _jsx(Replay, {}), fullWidth: true, children: "\u041F\u043E\u043F\u0440\u043E\u0431\u0443\u0439\u0442\u0435 \u043F\u0435\u0440\u0435\u0437\u0430\u0433\u0440\u0443\u0437\u0438\u0442\u044C \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0443" })), isMobileApp() && (_jsx(Button, { component: Link, href: branding.server_url, target: "_blank", variant: "contained", color: "info", startIcon: _jsx(Language, {}), fullWidth: true, children: "\u0418\u043B\u0438 \u0437\u0430\u0439\u0442\u0438 \u0447\u0435\u0440\u0435\u0437 \u0432\u0435\u0431-\u0432\u0435\u0440\u0441\u0438\u044E" }))] })] }));
}
export class ErrorBoundary extends Component {
    errors;
    errorInfo;
    constructor(props) {
        super(props);
        this.state = { hasError: false };
        this.errors = [];
        this.errorInfo = { componentStack: '' };
    }
    static getDerivedStateFromError() {
        return { hasError: true };
    }
    componentDidCatch(error, errorInfo) {
        console.error('error: ', error, 'errorInfo: ', errorInfo);
    }
    render() {
        if (this.state.hasError) {
            return _jsx(ErrorBoundaryView, { title: "\u0423\u043F\u0441... \u0447\u0442\u043E-\u0442\u043E \u043F\u043E\u0448\u043B\u043E \u043D\u0435 \u0442\u0430\u043A \uD83D\uDE14" });
        }
        return this.props.children;
    }
}
